import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum Channel {
  whatsapp = 'whatsapp',
  viber = 'viber',
}

interface ChannelsState {
  channel: Channel;
}

const initialState: ChannelsState = { channel: Channel.whatsapp };

const channelsSlice = createSlice({
  name: 'channels',
  initialState,
  reducers: {
    setChannel: (state, action: PayloadAction<Channel>) => {
      state.channel = action.payload;
    },
  },
});

export const { setChannel } = channelsSlice.actions;

export default channelsSlice.reducer;
